import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

@Directive({
    selector: '[reUsernameValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: UsernameValidatorDirective, multi: true }],
    standalone: false
})
export class UsernameValidatorDirective implements Validator {

  constructor() { }

  usernameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value)
        return null;

      if (value.indexOf('@') >= 0) {
        return { 'format': true };
      }
      return null;
    };
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    return this.usernameValidator()(control);
  }


}
